import { render } from "./PageIssuesPanel.vue?vue&type=template&id=da38fea4"
import script from "./PageIssuesPanel.vue?vue&type=script&lang=js"
export * from "./PageIssuesPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__